/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Promise_OverlineInputs */

const en_mk_promise_overline = /** @type {(inputs: Mk_Promise_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our promise`)
};

const id_mk_promise_overline = /** @type {(inputs: Mk_Promise_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Janji kami`)
};

/**
* | output |
* | --- |
* | "Our promise" |
*
* @param {Mk_Promise_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_promise_overline = /** @type {((inputs?: Mk_Promise_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Promise_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_promise_overline(inputs)
	return en_mk_promise_overline(inputs)
});